import styled from 'styled-components';

export const CategoryWrapper = styled.div`
  margin: 2rem 0;

  table {
    min-height: unset !important;
  }
`;
